module.exports = __webpack_public_path__ + "img/Settings Icon - charcoal.89802c87.svg";